import { createScenario } from '@funtech-int/rival';
import { lazy } from '@funtech-int/rival-react';

import { suggestWidget } from './widgets';

const scenario = createScenario((ctx) => {
    ctx.addWidget({
        widget: suggestWidget,
        component: lazy(() => import('./components/Suggest/Suggest')),
    });
});

export default scenario;
